export var MoveTypes;
(function (MoveTypes) {
    MoveTypes["Magical"] = "magical";
    MoveTypes["Physical"] = "physical";
})(MoveTypes || (MoveTypes = {}));
